import { Paper, Stack } from "@mui/material";
import {
    AccountCustomerClubDetailDto,
    AccountScoreLevelDefinition,
} from "../../../api/psc";
import { CardInformation } from "../../../components/exports";
import { separateByComma } from "../../../utils/string";
import AccountScoreProgressItem from "./AccountScoreProgressItem";

type TProps = {
    levels: AccountScoreLevelDefinition[];
    accountLoyalty: AccountCustomerClubDetailDto;
};

const colors = [
    {
        first: "#4E75D3",
        second: "#555BD0",
    },
    {
        first: "#555BD0",
        second: "#5A41CB",
    },
    {
        first: "#5A41CB",
        second: "#6127C7",
    },
    {
        first: "#6127C7",
        second: "#6516C4",
    },
];

export default function CustomerSupportLoyaltyProgressBar(props: TProps) {
    const { levels, accountLoyalty } = props;

    const calculateProgress = (
        currentLevel: AccountScoreLevelDefinition,
        nextLevel?: AccountScoreLevelDefinition
    ) => {
        let progress = 0;
        const relativeLevelScore = accountLoyalty.score - currentLevel.score;

        if (nextLevel) {
            const relativeTotalScore = nextLevel.score - currentLevel.score;

            progress = (relativeLevelScore / relativeTotalScore) * 100;
        } else {
            progress = (relativeLevelScore / 500_000_000) * 100;
        }

        return progress;
    };

    return (
        <Paper sx={{ p: 3 }}>
            <Stack
                direction="row"
                sx={{ mb: 2 }}
                justifyContent="space-between"
                spacing={1}
            >
                {levels.map((currentLevel, i) => {
                    const nextLevel = levels[i + 1];

                    const progress = calculateProgress(currentLevel, nextLevel);

                    return (
                        <AccountScoreProgressItem
                            key={currentLevel.displayName}
                            colors={colors[i]}
                            item={currentLevel}
                            progress={progress}
                        />
                    );
                })}
            </Stack>

            <Stack spacing={1}>
                <CardInformation
                    title="سطح فعلی شما"
                    value={accountLoyalty.scoreLevelDefinition.displayName}
                />
                <CardInformation
                    title="امتیاز فعلی شما"
                    value={separateByComma(accountLoyalty?.score.toString())}
                />
            </Stack>
        </Paper>
    );
}
